import { saveAs } from 'file-saver';
import RestClient from 'rest_client/rest_client';

export function download(url, params, fileName, method = 'GET', mime = 'application/octet-stream', responseType = 'blob') {	
	RestClient.load(url, params, method, mime, { engine: createRestClientEngine(responseType)})
		.then(response => {					
			saveAs(response.entity, fileName);						
		});
}

function createRestClientEngine(responseType) {
	function HttpRequest() {
		const xhr = new XMLHttpRequest();
		xhr.open("#","#");
		xhr.responseType = responseType;
		Object.defineProperty(xhr, 'responseText', {get: function() { return this.response }});
		return xhr;
	}
	HttpRequest.prototype = Object.create(XMLHttpRequest.prototype);
	return HttpRequest;
}

export default {
	download
}
